export default "__VITE_ASSET__C2_oiLR3__"